import AddIcon from 'material-ui/svg-icons/content/add';
import * as React from 'react';
import { ProjectViews } from '../../abstract';
// tslint:disable-next-line:ordered-imports
import { Typography, IconButton } from '@material-ui/core';
import DeleteIcon from 'material-ui/svg-icons/action/delete';
import { Views } from '../../../abstract';

interface IDashboardGrabFormAddEditViewProps extends Interfaces.IViewProps {
    onSave: () => void
    onNewField: () => void
    onDeleteField: (i: number) => void
}

class DashboardGrabFormAddEditView<P, S> extends ProjectViews.CommonView<P & IDashboardGrabFormAddEditViewProps, S> {

    constructor(props: any) {
        super(props);
    }

    public validateForm() {
        const { onSave } = this.props;
        const { model } = this.state;
        if (model['name']) {
            if (model['actionText'].ru && model['actionText'].en) {
                if (model['actionText'].ru && model['actionText'].en) {
                    if (model['title'].ru && model['title'].en) {
                        if (model['fields'].length) {
                            model['fields'].forEach((field: any, i: number) => {
                                if (field.key && field.ru && field.en) {
                                    if(i === model['fields'].length-1){
                                        onSave();
                                    }
                                } else {
                                    this.setState({ error: 'Заполни все значения и на всех языках для поля!' })
                                }
                            });
                        } else {
                            this.setState({ error: 'Добавьте хотя бы одно поле!' })
                        }
                    } else {
                        this.setState({ error: 'Заполните загловок формы!' })
                    }
                } else {
                    this.setState({ error: 'Заполните контент УТП на обоих языках!' })
                }
            } else {
                this.setState({ error: 'Заполните  текст кнопки действия!' })
            }
        } else {
            this.setState({ error: 'Заполните наименование формы!' })
        }
    }

    public renderFullWidthSide() {
        const { model, languageTabValue } = this.state;
        const { onDeleteField, onNewField } = this.props;
        return (
            <React.Fragment>
                <Views.TextField
                    floatingLabelText="Наименование"
                    fullWidth={true}
                    data-field-type="nml"
                    name="name"
                    value={model['name'] ? model['name'] : ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Текст кнопки действия"
                    fullWidth={true}
                    name="actionText"
                    value={model['actionText'] && model['actionText'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Заголовок"
                    fullWidth={true}
                    name="title"
                    value={model['title'] && model['title'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Views.TextField
                    floatingLabelText="Описание (не более 250 символов)"
                    fullWidth={true}
                    multiLine={true}
                    maxlength="250"
                    name="subtitle"
                    value={model['subtitle'] && model['subtitle'][languageTabValue] || ''}
                    onChange={(e) => this.onTextChange(e)}
                />
                <Typography variant="title" style={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', marginTop: 30 }}>
                    Поля
                    <IconButton onClick={() => onNewField()}>
                        <AddIcon />
                    </IconButton>
                </Typography>
                {model.fields.length ? <div style={{ width: '100%' }}>
                    {model.fields.map((f: any, i: number) => {
                        return (
                            <div key={i} style={{ width: '100%', display: 'inline-flex', flexDirection: 'row', flexGrow: 1, justifyContent: 'center', alignItems: 'center' }}>
                                <Views.TextField
                                    floatingLabelText="Ключ"
                                    fullWidth={true}
                                    data-field-type="nml"
                                    name="fields"
                                    value={model['fields'][i] && model['fields'][i].key || ''}
                                    onChange={(e) => this.onTextChange(e, `fields key`, i, true)}
                                />
                                <span style={{ margin: '0 10px', marginTop: '20px' }}>:</span>
                                <Views.TextField
                                    floatingLabelText="Наименование"
                                    fullWidth={true}
                                    data-field-type="nml"
                                    name="fields"
                                    value={model['fields'][i] && model['fields'][i][languageTabValue] || ''}
                                    onChange={(e) => this.onTextChange(e, `fields ${languageTabValue}`, i, true)}
                                />
                                <IconButton onClick={() => onDeleteField(i)} style={{ marginTop: 20 }}>
                                    <DeleteIcon />
                                </IconButton>
                            </div>
                        )
                    })}
                </div> : null}
            </React.Fragment>
        )
    }
}

export default DashboardGrabFormAddEditView;



// WEBPACK FOOTER //
// ./src/app/dashboard/grabforms/addedit/GrabFormAddEditView.tsx